var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    {
      staticClass: "fill-height"
    },
    [
      _c("gg-card-header", [_vm._v(" Post Ticket Reply ")]),
      _c(
        "gg-card-text",
        {
          staticClass: "px-4"
        },
        [
          !_vm.validated
            ? _c(
                "div",
                [
                  _c("v-textarea", {
                    attrs: {
                      value: "Type here to Reply to Ticket",
                      rows: "4",
                      outlined: "",
                      disabled: "",
                      "background-color": "grey"
                    }
                  }),
                  _c(
                    "v-card-actions",
                    {
                      staticClass: "pt-0 pl-0"
                    },
                    [
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            secondary: "",
                            loading: _vm.loading,
                            disabled: ""
                          }
                        },
                        [_vm._v(" Post Reply ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("v-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rules.message,
                        expression: "rules.message"
                      }
                    ],
                    staticClass: "gg-input",
                    attrs: {
                      dense: "",
                      placeholder: "Type here to Reply to Ticket",
                      rows: "4",
                      outlined: "",
                      "data-vv-name": "message",
                      "data-vv-as": "Reply",
                      "error-messages": _vm.errors.collect("message")
                    },
                    model: {
                      value: _vm.model.message,
                      callback: function callback($$v) {
                        _vm.$set(_vm.model, "message", $$v)
                      },
                      expression: "model.message"
                    }
                  }),
                  _c(
                    "v-card-actions",
                    {
                      staticClass: "pt-0 pl-0"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-block"
                        },
                        [
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                loading: _vm.loading
                              },
                              on: {
                                click: _vm.submitReply
                              }
                            },
                            [_vm._v(" Post Reply ")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "v-card-actions",
                    {
                      staticClass: "pt-0 pl-0"
                    },
                    [
                      _c("attachments", {
                        ref: "attachments",
                        staticClass: "d-block",
                        on: {
                          update: _vm.setAttachment
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }